"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBarBase = exports.TopBar = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_skip_nav_1 = require("@hopin-team/ui-skip-nav");

var react_1 = tslib_1.__importDefault(require("react"));

var context_1 = require("./context");

var hamburger_menu_1 = require("./partials/hamburger-menu");

var center_1 = require("./styled/center");

var root_1 = require("./styled/root");

var slots_1 = require("./styled/slots");

var TopBar = function TopBar(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      _b = _a.pattern,
      pattern = _b === void 0 ? 'primary' : _b,
      skipNavLink = _a.skipNavLink,
      leading = _a.leading,
      trailing = _a.trailing,
      nav = _a.nav,
      heading = _a.heading,
      _c = _a.align,
      align = _c === void 0 ? 'left' : _c;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'TopBar',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var isInverse = pattern === 'inverse';
  return react_1.default.createElement(react_1.default.Fragment, null, skipNavLink && react_1.default.createElement(ui_skip_nav_1.SkipNavLink, {
    href: skipNavLink === null || skipNavLink === void 0 ? void 0 : skipNavLink.href
  }, skipNavLink === null || skipNavLink === void 0 ? void 0 : skipNavLink.text), react_1.default.createElement(root_1.Root, {
    className: rootClasses,
    "data-testid": testID,
    isInverse: isInverse
  }, react_1.default.createElement(context_1.TopBarContext.Provider, {
    value: {
      isInverse: isInverse
    }
  }, leading && react_1.default.createElement(slots_1.LeadingSlot, null, react_1.default.createElement(hamburger_menu_1.HamburgerMenu, null), leading), nav && react_1.default.createElement(center_1.Nav, {
    align: align
  }, nav), heading && react_1.default.createElement(center_1.Heading, {
    align: align,
    element: "h1",
    color: isInverse ? 'grey-white' : 'grey-dark'
  }, heading), trailing && react_1.default.createElement(slots_1.TrailingSlot, null, trailing))));
};

exports.TopBarBase = TopBar;
var TopBarWithSpace = (0, ui_helper_with_space_1.withSpace)(TopBar);
exports.TopBar = TopBarWithSpace;